import { render, staticRenderFns } from "./thematicManagement.vue?vue&type=template&id=1301b831"
import script from "./thematicManagement.vue?vue&type=script&lang=js"
export * from "./thematicManagement.vue?vue&type=script&lang=js"
import style0 from "./thematicManagement.vue?vue&type=style&index=0&id=1301b831&prod&scpoed=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports